/**
 * Keyboard-dismiss gate — web implementation.
 *
 * Browsers have no software keyboard that overlaps layout in the way native does,
 * so the action runs on the next frame after blurring the focused element.
 */
export const runAfterKeyboardDismiss = (
  action?: () => void,
): Promise<void> =>
  new Promise((resolve) => {
    const active = typeof document === 'undefined' ? null : document.activeElement;
    if (active instanceof HTMLElement) {
      active.blur();
    }
    requestAnimationFrame(() => {
      try {
        action?.();
      } finally {
        resolve();
      }
    });
  });

export default runAfterKeyboardDismiss;
